module.exports = __webpack_public_path__ + "img/mascot-4.b7aa52d7.png";